export default __webpack_public_path__ + "static/media/polygon_47.f81d7e00.svg";